import ArticleLayout from './ArticleLayout'
import { valoresFaqItems } from './seo/valoresPage'
import { acompanhamentoPath, bookingLabel, individualBookingUrl, individualWhatsAppUrl, youtubeChannelUrl } from './siteDestinations'
import { ArticleCard, ArticleClosing, ArticleFaq, ArticleList, ArticleSection } from './ui/Article'
import { ActionLink } from './ui/Workshop' // termo-ok: nome técnico do arquivo de componentes

export default function ValoresPage() {
  return <ArticleLayout
    eyebrow="Valores · acompanhamento individual"
    title={<>Primeiro, o seu caso. <em>Depois, a gente combina o valor.</em></>}
    intro="O acompanhamento individual começa com uma conversa gratuita de 30 minutos. Você me conta o que faz no computador, conhece um caminho possível e decide se quer continuar comigo."
    rogerio={{ pose: 'pedindo-esclarecimento', text: 'Tudo combinado antes de continuar.' }}
    facts={[[ '30 min', 'de primeira conversa gratuita' ], [ '9 h', 'de acompanhamento pago, se continuar' ], [ 'Combinado', 'o valor, antes de qualquer compromisso' ], [ 'Gratuito', 'o canal para aprender por conta própria' ]]}
    flow={['conversar', 'entender o seu caso', 'conhecer o caminho', 'combinar o valor', 'escolher', 'fazer junto']}
    secondary={{ href: '#valores-individual', label: 'Entender os valores' }}
  >
    <ArticleSection id="valores-individual" eyebrow="Se continuar" title="Acompanhamento individual">
      <ArticleCard tone="sage" title="O valor é combinado na primeira conversa.">
        <p>São 9 horas de acompanhamento pago, além dos 30 minutos gratuitos. Os encontros acontecem por videochamada, de 1 a 2 horas por semana, conforme a sua agenda.</p>
        <p>Na conversa, a gente olha para o seu caso e combina o valor e a distribuição das horas. Você sabe as condições antes de qualquer compromisso.</p>
        <ArticleList>
          <li>Encontros individuais comigo, na sua tela e nas suas tarefas.</li>
          <li>Dúvidas pelo WhatsApp entre os encontros.</li>
          <li>Qualquer material que eu enviar é seu.</li>
          <li>As aulas não são gravadas; só são transcritas com a sua permissão.</li>
        </ArticleList>
        <p>Assinaturas das ferramentas são pagas pelo participante, separadamente do acompanhamento.</p>
        <ActionLink href={individualBookingUrl} target="_blank" rel="noopener noreferrer">{bookingLabel}</ActionLink>
        <p><a href={acompanhamentoPath}>Veja como funciona o acompanhamento →</a></p>
      </ArticleCard>
    </ArticleSection>
    <ArticleSection id="valores-gratuito" eyebrow="Para começar" title="Você pode começar sem pagar.">
      <p>A primeira conversa é gratuita. Você sai com um primeiro passo para tentar sozinho e pode decidir depois se quer companhia.</p>
      <ArticleCard tone="sky" title="Canal no YouTube: gratuito">
        <p>As aulas do canal continuam gratuitas. Você pode conhecer meu jeito de ensinar e experimentar por conta própria.</p>
        <ActionLink variant="secondary" href={youtubeChannelUrl} target="_blank" rel="noopener noreferrer">Abrir o canal no YouTube</ActionLink>
      </ArticleCard>
    </ArticleSection>
    <ArticleSection id="valores-duvidas" eyebrow="Antes de decidir" title="Dúvidas sobre valores">
      <ArticleFaq idPrefix="valores-faq" items={valoresFaqItems} />
    </ArticleSection>
    <ArticleClosing
      eyebrow="Todo começo cabe numa conversa"
      title="Vamos olhar para o seu caso?"
      action={{ href: individualBookingUrl, label: bookingLabel, external: true }}
      secondary={{ href: youtubeChannelUrl, label: 'Conhecer o canal gratuito', external: true }}
      note={<><a href={individualWhatsAppUrl} target="_blank" rel="noopener noreferrer">Prefere tirar uma dúvida antes? Me chame no WhatsApp ↗</a></>}
      rogerio={{ pose: 'concluido', text: 'Eu fico por aqui. A conversa é com o Arthur.' }}
    >
      Você me conta o que faz no computador. Em 30 minutos, a gente encontra um primeiro passo para você tentar sozinho. A primeira conversa é gratuita.
    </ArticleClosing>
  </ArticleLayout>
}
